import { useMemo } from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';
import { useSettingsStore } from 'app/store';

import { Error404ComputerImage, Error404Image, Error404RobotImage } from 'shared/assets/icons';
import { useCustomNavigate } from 'shared/hooks/useCustomNavigate';

export const Error404 = () => {
  const { customNavigate } = useCustomNavigate();
  const { darkTheme } = useSettingsStore();

  const getRandom123 = useMemo(() => {
    const random123 = Math.floor(Math.random() * 3) + 1;
    return random123;
  }, []);

  const getRandomImage = () => {
    switch (getRandom123) {
      case 1:
        return <Error404Image />;
      case 2:
        return <Error404RobotImage />;
      case 3:
        return <Error404ComputerImage />;
    }
  };

  return (
    <>
      <Box
        style={{
          background: 'var(--mui-palette-background-login)',
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: '0',
          left: '0'
        }}>
        <Stack
          gap={'137px'}
          direction={'row'}
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)'
          }}>
          <Stack position={'relative'} zIndex={1}>
            <Typography
              variant='h1'
              fontSize={'340px'}
              letterSpacing={'0.25px'}
              fontWeight={'700'}
              color={'#fff'}
              textAlign={'center'}>
              404
            </Typography>
            <Typography
              variant='h3'
              color={'#fff'}
              fontSize={'46px'}
              letterSpacing={'0.25px'}
              fontWeight={'700'}
              noWrap>
              Sorry, we couldn't find this page
            </Typography>
            <Button
              variant='contained'
              color={darkTheme ? 'primary' : 'secondary'}
              onClick={() => customNavigate('/')}
              sx={{
                margin: '50px auto 0',
                fontSize: '18px',
                lineHeight: 'normal',
                p: '14px 34px'
              }}>
              Back to home page
            </Button>
          </Stack>
          <Box
            sx={{
              position: getRandom123 === 1 ? 'absolute' : 'relative',
              top: getRandom123 === 1 ? '-45%' : '-0%',
              left: getRandom123 === 1 ? '50%' : '0%',
              transform: getRandom123 === 1 ? 'translate(-50%, 0)' : 'translate(0%, 0)'
            }}>
            {getRandomImage()}
          </Box>
        </Stack>
      </Box>
    </>
  );
};
